// extracted by mini-css-extract-plugin
export default {"chips":"ChipsGroup-module__chips__Z-FU-","chip":"ChipsGroup-module__chip__FVgRm"};